import {ProjectStatus} from "~/types/ProjectStatus";
import type {FormState} from "~/types/FormState";

export const projectStatusColor = (status: ProjectStatus) => {
    if (!status) return "neutral";

    if (status === ProjectStatus.Archived) return "neutral";
    if (status === ProjectStatus.InProgress) return "info";
    if (status === ProjectStatus.Complete) return "success";
};

export const projectStatusLabel = (status: ProjectStatus) => {
    if (!status) return "";

    if (status === ProjectStatus.Archived) return "Brouillon";
    if (status === ProjectStatus.InProgress) return "En cours";
    if (status === ProjectStatus.Complete) return "Terminé";
};

export const projectStatusClass = (status: ProjectStatus) => {
    if (status === ProjectStatus.Complete) return "!bg-green-100 !border-green-950 !text-green-950";
    if (status === ProjectStatus.InProgress) return "!bg-teal-100 !border-teal-950 !text-teal-950";
    if (status === ProjectStatus.Archived) return "!bg-gray-100 !border-gray-950 !text-gray-950";

    return "";
};

export const chaptersCountLabel = (count: number) => {
    return count + " " + (count === 1 ? "chap." : "chap.");
};

export const getImageUrl = (image: any) => {
    if (image instanceof File) {
        return URL.createObjectURL(image);
    }
    return image;
};
